import { apiConfig } from '@yandex-int/k-common/client/api/config';
import { LESSON_STATUS } from '@yandex-int/k-common/typings';

// eslint-disable-next-line complexity
export const getRedirectPathForLesson = (status: LESSON_STATUS): string => {
    const staticUrls: Record<string, string> = apiConfig.getStaticUrls();

    switch (status) {
        case LESSON_STATUS.NOT_ASSIGNED:
            return staticUrls.labSubjectLessonsDrafts;
        case LESSON_STATUS.ASSIGNED:
        case LESSON_STATUS.ASSIGNED_IN_FUTURE:
        case LESSON_STATUS.IN_PROGRESS:
            return staticUrls.labSubjectLessonsActive;
        case LESSON_STATUS.NOT_SOLVED:
        case LESSON_STATUS.FINISHED:
        case LESSON_STATUS.FINISH_FORCED:
        case LESSON_STATUS.WAIT_FOR_RESULTS:
            return staticUrls.labSubjectLessonsComplete;
        default:
            return staticUrls.labSubjectLessonsComplete;
    }
};
